// extracted by mini-css-extract-plugin
export var brand = "carrousel-module--brand--2eiPK";
export var carrouselContainer = "carrousel-module--carrouselContainer--21cp_";
export var proyectContainer = "carrousel-module--proyectContainer--3jY8x";
export var workName = "carrousel-module--workName--XZxHE";
export var stroke = "carrousel-module--stroke--3h3f8";
export var itemContainer = "carrousel-module--itemContainer--3cnFc";
export var lightbox = "carrousel-module--lightbox--3n8KD";
export var slickSlider = "carrousel-module--slick-slider--1JfZu";